import * as React from 'react';
import { createStyles, withStyles, WithStyles } from '@material-ui/core';
import { GridCellProps } from '@progress/kendo-react-grid';
import moment from 'moment';

const styles = () => createStyles({});

type Props = WithStyles<typeof styles> & GridCellProps;

const ScheduledDateCell = ({ dataItem, rowType }: Props) => {
  if (
    rowType === 'groupHeader' ||
    rowType === 'groupFooter' ||
    rowType !== 'data'
  ) {
    return null;
  }

  return (
    <td style={{ verticalAlign: 'top' }}>
      {moment(dataItem.scheduledDate).format('DD.MM.YYYY')}
    </td>
  );
};

export default withStyles(styles)(ScheduledDateCell);
